export default "__VITE_ASSET__BzAE37yK__"